









































































































import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { ExchangeTradesModule } from '@/store/modules/exchangeTrades';
import Trade from './Trade.vue';
import { Exchange, VolumeHistory, VolumePerPeriod } from '@/types/trade';

const padVolumes = (
  now: number,
  volumesPerperiod: VolumePerPeriod[],
  length: number,
  period: number,
) => {
  const nowPerPeriod = Math.floor(now / period);
  const timestampArray = Array(length)
    .fill(0)
    .map((e, i) => nowPerPeriod - i);
  return timestampArray.sort().map((timestamp) => {
    const trades = volumesPerperiod.find((v) => {
      return v.timestamp === timestamp;
    });
    if (trades) {
      return trades;
    } else {
      return {
        timestamp,
        size: 0,
      };
    }
  });
};

@Component({
  name: 'MarketVolume',
  filters: {
    floor(value: number) {
      return Math.floor(value);
    },
  },
})
export default class MarketVolume extends Vue {
  get BuyVolume() {
    const {
      bitfinex,
      bitflyer,
      bitmex,
    } = ExchangeTradesModule.exchangeVolumePerPeriod;
    return bitfinex.BUY + bitflyer.BUY + bitmex.BUY;
  }
  get SellVolume() {
    const {
      bitfinex,
      bitflyer,
      bitmex,
    } = ExchangeTradesModule.exchangeVolumePerPeriod;
    return bitfinex.SELL + bitflyer.SELL + bitmex.SELL;
  }
  get formatedVolumeHistory() {
    const now = Date.now();
    const {
      bitfinex,
      bitflyer,
      bitmex,
    } = ExchangeTradesModule.exchangeVolumeHistory;
    const bitfinexBUY = padVolumes(now, bitfinex.BUY, 11, 5000);
    const bitfinexSELL = padVolumes(now, bitfinex.SELL, 11, 5000);
    const bitflyerBUY = padVolumes(now, bitflyer.BUY, 11, 5000);
    const bitflyerSELL = padVolumes(now, bitflyer.SELL, 11, 5000);
    const bitmexBUY = padVolumes(now, bitmex.BUY, 11, 5000);
    const bitmexSELL = padVolumes(now, bitmex.SELL, 11, 5000);
    const totalBuyArray = bitfinexBUY.map((v, i) => {
      return v.size + bitflyerBUY[i].size + bitmexBUY[i].size;
    });
    const totalSellArray = bitfinexSELL.map((v, i) => {
      return v.size + bitflyerSELL[i].size + bitmexSELL[i].size;
    });
    const maxVolume = Math.max(...totalBuyArray, ...totalSellArray);
    if (maxVolume > 0) {
      const bitflyerBar = bitflyerBUY.map((v, i) => {
        return {
          height: ((v.size + bitflyerSELL[i].size) * 103) / maxVolume,
          y: 103 - (v.size * 103) / maxVolume,
        };
      });
      const bitfinexBar = bitflyerBar.map((v, i) => {
        return {
          height:
            v.height +
            ((bitfinexBUY[i].size + bitfinexSELL[i].size) * 103) / maxVolume,
          y: v.y - (bitfinexBUY[i].size * 103) / maxVolume,
        };
      });
      const bitmexBar = bitfinexBar.map((v, i) => {
        return {
          height:
            v.height +
            ((bitmexBUY[i].size + bitmexSELL[i].size) * 103) / maxVolume,
          y: v.y - (bitmexBUY[i].size * 103) / maxVolume,
        };
      });
      return {
        maxVolume,
        bitflyerBar,
        bitmexBar,
        bitfinexBar,
      };
    }
    return {
      maxVolume: 0,
      bitflyerBar: [],
      bitmexBar: [],
      bitfinexBar: [],
    };
  }
}
